// ============================================
// THEME TOGGLE (Light/Dark/System)
// ============================================

import Alpine from 'alpinejs';

export function registerThemeToggle(): void {
    Alpine.data('themeToggle', () => ({
        theme: localStorage.getItem('theme') || 'system',

        init(): void {
            this.applyTheme();

            window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', () => {
                if (this.theme === 'system') {
                    this.applyTheme();
                }
            });
        },

        setTheme(newTheme: string): void {
            this.theme = newTheme;
            localStorage.setItem('theme', newTheme);
            this.applyTheme();
        },

        applyTheme(): void {
            // Dark mode disabled — corporate light-only theme
            document.documentElement.classList.remove('dark-mode');
            document.body.classList.remove('dark-mode');
        },

        getCurrentTheme(): string {
            return this.theme;
        },

        isDark(): boolean {
            if (this.theme === 'dark') return true;
            if (this.theme === 'light') return false;
            return window.matchMedia('(prefers-color-scheme: dark)').matches;
        }
    }));
}
